/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useContext} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import ConfigContext from '../../contexts/Config/ConfigContext';
import { baseUrl } from '../../../Helpers/Requests';

const AuthLayout = () => {
  const config = useContext(ConfigContext);
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])
  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100' style={{position: 'relative', width:'100vw', height: '100vh'}}>
      <div style={{position: 'absolute', width:'100vw', height: '100vh', objectFit: 'cover', zIndex: '-1', backgroundColor:'rgba(0, 0, 0, .5'}}></div>
      <video autoPlay loop muted style={{position: 'absolute', width:'100vw', height: '100vh', objectFit: 'cover', zIndex: '-2'}}>
        <source src="https://apiemail.bckcode.com.br/blackbank.mp4" type="video/mp4"/>
      </video>
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px p-10' style={{backgroundColor: 'rgba(255, 255, 255, .13)', backdropFilter: 'blur(10px)', borderRadius: 14}}>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        {config.footer.mostrar && (
          <div className='d-flex flex-center flex-wrap px-5'>
            {/* begin::Links */}
            {/* <div className='d-flex fw-semibold text-primary fs-base '>
              &copy; {config.footer.texto} &nbsp;<a className='opacity-75-hover text-warning' href={config.footer.url}>{config.footer.criado_por}</a>
            </div> */}
            {/* end::Links */}
          </div>
        )}
        {/* end::Footer */}
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      <div
        className='d-none flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
        style={config.login.background && config.login.background !== "" ? {backgroundImage: `url(${baseUrl(config.login.background)})`} : {}}
      >
        {/* begin::Content */}
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
          {/* begin::Logo */}
          <Link to='/' className='mb-12'>
            {config.logo && config.logo !== "" && <img alt='Logo' src={config.logo} className='h-75px notranslate' />}
          </Link>
          {/* end::Logo */}

          {/* begin::Image */}
          {config.login.inside && config.login.inside !== "" && <img
            className='mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20'
            src={baseUrl(config.login.inside)}
            alt=''
          />}
          {/* end::Image */}

          {/* begin::Title */}
          {config.login.title && <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
            {config.login.title}
          </h1>}
          {/* end::Title */}

          {/* begin::Text */}
          {config.login.text && <div className='text-white fs-base text-center'>
            {config.login.text}
          </div>}
          {/* end::Text */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
    </div>
  )
}

export {AuthLayout}
